export default function removeProtocol(url) {
  return url.replace(/^https:\/\/|^http:\/\//, '').replace(/\/$/, '');
}
